export const HIDE_EMAIL_RECOMMEND_CONNECTION = 'hideEmailRecommendConnection';

export const NO_SYNC_AUTH_DOMAIN = 'NO_SYNC_AUTH_DOMAIN';
export const NO_SYNC_GMAIL = 'NO_SYNC_GMAIL';
export const NO_PROMPT = 'NO_SYNC_PROMPT';

const NO_SYNC_AUTH_TITLE = 'Increase Trust To Your Emails';
const NO_SYNC_GMAIL_TITLE = 'Send Emails From Your Gmail Account';

const NO_SYNC_AUTH_LEARN_MORE =
  'https://lonewolf.my.site.com/s/article/LD-Authenticate-a-personal-email-domain-LionDesk';
const NO_SYNC_GMAIL_LEARN_MORE =
  'https://lonewolf.my.site.com/s/article/LD-Sync-an-email-account-LionDesk';

const NO_SYNC_AUTH_PROMPT = {
  title: NO_SYNC_AUTH_TITLE,
  message: `It looks like you own a domain. Please verify your email domain to help us deliver all your emails to contact's inboxes. <a href="${NO_SYNC_AUTH_LEARN_MORE}" target="_blank">Learn More.</a>`,
  connectActionText: 'Verify My Domain',
  connectActionLink: '/communications/email/management',
  otherProviderLink: '/email-integrations?open-drawer=true',
};
const NO_SYNC_GMAIL_PROMPT = {
  title: NO_SYNC_GMAIL_TITLE,
  message: `It looks like you own a Gmail account. Connect your email account to LionDesk to send, receive and track emails in your LionDesk CRM. <a href="${NO_SYNC_GMAIL_LEARN_MORE}" target="_blank">Learn More.</a>
  <br>
  <br>
  All email communications will show up under 'inbox' on a contact's detail page.`,
  connectActionText: 'Connect to GMAIL',
  connectActionLink: '/email-integrations?open-drawer=true&email-provider=gmail',
  otherProviderLink: '/email-integrations?open-drawer=true',
};
const NO_PROMPT_PROMPT = {
  title: '',
  message: ``,
  connectActionText: '',
  connectActionLink: '',
  otherProviderLink: '',
};

export const NO_SYNC_PROMPT = Object.freeze({
  [NO_SYNC_AUTH_DOMAIN]: NO_SYNC_AUTH_PROMPT,
  [NO_SYNC_GMAIL]: NO_SYNC_GMAIL_PROMPT,
  [NO_PROMPT]: NO_PROMPT_PROMPT
});
